import { jsxs as t, jsx as e } from "react/jsx-runtime";
import r from "@mui/joy/Typography";
import { Grid as o, Wrapper as i } from "./styled.js";
const l = ({ title: l2, children: m }) => t(o, { children: [e(r, { level: "title-sm", textColor: "neutral.700", fontWeight: 600, children: l2 }), e(i, { children: m })] });
export {
  l as FormSection,
  l as default
};
//# sourceMappingURL=index.js.map
